import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import api from "../../api";

// Phase 4C, §11. Reuses the EXISTING project-create API
// (POST /form-assignment-options/projects, a thin passthrough to
// services/projectService.js's own create()) — no second project table,
// no duplicated validation. The authenticated caller becomes the project's
// owner (trusted server-side; never a client-supplied owner id).
export default function AddProjectDialog({ show, onClose, onCreated }) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [saving, setSaving] = useState(false);

  const reset = () => {
    setName("");
    setDescription("");
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  const handleCreate = async () => {
    if (!name.trim()) {
      toast.warning("Project name is required");
      return;
    }
    setSaving(true);
    try {
      const res = await api.post("/form-assignment-options/projects", { name: name.trim(), description: description.trim() || null });
      toast.success("Project created");
      reset();
      onCreated(res.data?.data);
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to create project");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton><Modal.Title>Add Project</Modal.Title></Modal.Header>
      <Modal.Body>
        <Form.Label>Project Name</Form.Label>
        <Form.Control value={name} onChange={(e) => setName(e.target.value)} autoFocus />
        <Form.Label className="mt-3">Description (optional)</Form.Label>
        <Form.Control as="textarea" rows={2} value={description} onChange={(e) => setDescription(e.target.value)} />
      </Modal.Body>
      <Modal.Footer>
        <Button className="unit-btn unit-btn-light" onClick={handleClose}>Cancel</Button>
        <Button className="unit-btn unit-btn-primary" onClick={handleCreate} disabled={saving}>
          {saving ? "Creating..." : "Create Project"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
